import {Store} from '@tanstack/react-store'
import type {Point} from '@yandex-delivery/core/types'

import type {Descriptors} from '../api/definitions/form'
import type {SharingProvider} from '../types'

type StoreState = {
  ttl?: number
  descriptors?: Descriptors
  offerId?: string
  user_info: {
    location: Point
  }
  sharingProvider: SharingProvider
}

export const store = new Store<StoreState>({
  descriptors: [],
  user_info: {
    location: [37.6177, 55.755863],
  },
  sharingProvider: 'cargo-claims',
})
